const validateCreateMedia = ({ title, image, type, videoUrl }) => {
  const errors = {}

  if (!title?.trim()) {
    errors.title = 'Title is required'
  }

  if (type === 'video') {
    if (!videoUrl?.trim()) {
      errors.videoUrl = 'Video URL is required'
    } else if (!/^https?:\/\//i.test(videoUrl.trim())) {
      errors.videoUrl = 'Please enter a valid URL starting with http:// or https://'
    }
  } else {
    // type is "image" (default)
    if (!image) {
      errors.image = 'Image is required'
    }
  }

  return { errors, hasErrors: Object.keys(errors).length > 0 }
}

export default validateCreateMedia
